var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74996 2.91683L6.2837 6.44307C6.70499 6.77074 7.29493 6.77074 7.71622 6.44307L12.25 2.91683M3.03329 11.6668H10.9666C11.62 11.6668 11.9467 11.6668 12.1963 11.5397C12.4158 11.4278 12.5943 11.2493 12.7061 11.0298C12.8333 10.7803 12.8333 10.4536 12.8333 9.80016V4.20016C12.8333 3.54677 12.8333 3.22007 12.7061 2.97051C12.5943 2.75098 12.4158 2.57251 12.1963 2.46066C11.9467 2.3335 11.62 2.3335 10.9666 2.3335H3.03329C2.3799 2.3335 2.0532 2.3335 1.80364 2.46066C1.58411 2.57251 1.40564 2.75098 1.29379 2.97051C1.16663 3.22007 1.16663 3.54677 1.16663 4.20016V9.80016C1.16663 10.4536 1.16663 10.7803 1.29379 11.0298C1.40564 11.2493 1.58411 11.4278 1.80364 11.5397C2.0532 11.6668 2.3799 11.6668 3.03329 11.6668Z",
    stroke: "#F3F3F3",
    strokeWidth: 1.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a37ab262e9516ec99e235eeeb37beac1.svg";
export { ForwardRef as ReactComponent };